import React from "react";
import { ShieldCheckIcon } from "./icons";

interface PrivacySectionProps {
  sectionRef: React.RefObject<HTMLElement>;
}

export const PrivacySection: React.FC<PrivacySectionProps> = ({ sectionRef }) => (
  <section className="nsw-teachers-section" ref={sectionRef}>
    <div className="nsw-teachers-content">
      <div className="nsw-banner">
        <div className="nsw-content">
          <div className="nsw-visual">
            <div className="nsw-map-icon">
              <ShieldCheckIcon />
            </div>
          </div>
          <div className="nsw-text">
            <h3 className="nsw-title">Secure by Design - No Student Data Collected</h3>
            <p className="nsw-description">
              At Gymea, privacy comes first. Our platform is built to protect educators and schools by design - we never ask for, store, or share personally identifiable student information.
            </p>
            <p className="nsw-description">
              All document generation happens securely within Australia, with no data saved once your session ends.
            </p>
            <p className="nsw-description">
              Your school's information stays private, protected, and entirely under your control - always.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
);
